// Shared demo-brand detection. A brand counts as "demo" when it is the canonical
// demo brand, has DEMO status, or its name contains "demo" (covers the various
// *Demo Store* / *Demo* test brands Efe uses for presentations). Accepts either a
// brand object (from useAuth().selectedBrand) or a brand id string (falls back to
// the cached selectedBrand in localStorage to resolve name/status).
export const CANONICAL_DEMO_BRAND_ID = 'demo-brand-glowytics-2024';

export function isDemoBrand(brand) {
  if (!brand) return false;
  const b = typeof brand === 'string' ? { id: brand } : brand;
  if (b.id === CANONICAL_DEMO_BRAND_ID) return true;
  if (String(b.status || '').toUpperCase() === 'DEMO') return true;
  if (/demo/i.test(b.name || '')) return true;
  if (typeof brand === 'string') {
    try {
      const c = JSON.parse(localStorage.getItem('selectedBrand') || 'null');
      if (c && c.id === brand &&
        (String(c.status || '').toUpperCase() === 'DEMO' || /demo/i.test(c.name || ''))) {
        return true;
      }
    } catch (_) {}
  }
  return false;
}

// Small deterministic string hash so demo numbers are stable per seed (campaign
// name, month, …) instead of reshuffling on every render.
export function demoHash(str) {
  let h = 2166136261;
  const s = String(str || '');
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0);
}
